import Vue from "vue";
import {PAGE_IDS} from "../utils/constants"

Vue.mixin({
  data: function() {
    return {
      PAGE_IDS: PAGE_IDS,
    };
  },
});




// WEBPACK FOOTER //
// ./src/plugins/constants_mixin.js